import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { DashboardLayout } from "components/layout/components/DashboardLayout";
import { useGetUserInfo } from "hooks/useGetUserInfo";
import UploadPageHistory from "./components/upload-page-history";
import "./assets/style.css";
import { HomeOutlined, RightOutlined } from "@ant-design/icons";
import { routePath } from "config/routeMgt/routePath";

export default function PageHistory() {
  const navigate = useNavigate();

  const { userInfo } = useGetUserInfo();

  useEffect(() => {
    if (userInfo?.type === "talent") {
      navigate("/");
    }
  }, [userInfo, navigate]);

  const handleCVSmartScreen = () => {
    navigate(routePath.cvchat);
  };

  const handleUploadHistory = () => {
    navigate(routePath.cvchatHistory);
  };

  return (
    <DashboardLayout>
      <div className="px-4 pt-4">
        <h1 className="text-xl font-semibold text-gray-900">Upload History</h1>

        <p className="mt-1 text-sm text-gray-500">
          Upload talent CVs and get automatic ranking
        </p>

        <div className="mt-8">
          <h3 className="text-sm flex items-center gap-1 text-gray-700">
            <HomeOutlined className="text-gray-500" />

            <button
              type="button"
              onClick={handleCVSmartScreen}
              className="text-sm text-blue-600 hover:underline cursor-pointer bg-transparent border-0 p-0"
            >
              CV Smart Screen
            </button>

            <RightOutlined className="text-xs text-gray-400" />

            <button
              type="button"
              onClick={handleUploadHistory}
              className="text-sm text-blue-600 hover:underline cursor-pointer bg-transparent border-0 p-0"
            >
              Upload History
            </button>
          </h3>
        </div>
      </div>

      <div className="flex-1 overflow-auto p-4">
        <UploadPageHistory />
      </div>
    </DashboardLayout>
  );
}
